// Custom.js — ordercrabs.com

// === 1. Scroll-lock override ===
(function () {
  var style = document.createElement("style");
  style.textContent = [
    "body, html { position: static !important; top: auto !important; overflow: visible !important; overflow-x: clip !important; overflow-y: visible !important; }",
    "body.\\!overflow-clip, html.\\!overflow-clip { overflow: visible !important; overflow-y: visible !important; }",
    "body.pr-\\[--scrollbar-width\\] { padding-right: 0 !important; }",
  ].join("\n");
  document.head.appendChild(style);
})();

// === 2. "Added to Cart" toast notification ===
(function () {
  // Inject toast styles
  var style = document.createElement("style");
  style.textContent = `
    .atc-toast {
      position: fixed;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%) translateY(120px);
      z-index: 999999;
      background: #1a3873;
      color: #fff;
      padding: 14px 24px;
      border-radius: 50px;
      font-family: var(--typography-family-primary, "Roboto Condensed", sans-serif);
      font-size: 15px;
      font-weight: 600;
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: 10px;
      box-shadow: 0 8px 32px rgba(0,0,0,0.18);
      cursor: pointer;
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.4s ease;
      opacity: 0;
      pointer-events: none;
      white-space: nowrap;
      -webkit-tap-highlight-color: transparent;
    }
    .atc-toast.show {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
      pointer-events: auto;
    }
    .atc-toast svg {
      flex-shrink: 0;
    }
    .atc-toast .atc-toast-arrow {
      margin-left: 2px;
      transition: transform 0.2s ease;
    }
    .atc-toast:hover .atc-toast-arrow,
    .atc-toast:active .atc-toast-arrow {
      transform: translateX(3px);
    }
    @media (max-width: 768px) {
      .atc-toast {
        bottom: 20px;
        font-size: 14px;
        padding: 12px 20px;
        max-width: calc(100vw - 32px);
      }
    }
  `;
  document.head.appendChild(style);

  // Create toast element
  var toast = document.createElement("a");
  toast.href = "/cart";
  toast.className = "atc-toast";
  toast.innerHTML =
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm4.95 7.35l-5.5 5.5a.75.75 0 01-1.06 0l-2.5-2.5a.75.75 0 111.06-1.06l1.97 1.97 4.97-4.97a.75.75 0 111.06 1.06z" fill="currentColor"/>' +
    "</svg>" +
    '<span>Added to cart</span>' +
    '<svg class="atc-toast-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    "</svg>";
  document.body.appendChild(toast);

  var hideTimer = null;

  function showToast() {
    clearTimeout(hideTimer);
    toast.classList.add("show");
    hideTimer = setTimeout(function () {
      toast.classList.remove("show");
    }, 3500);
  }

  // Listen for the theme's productAddedToCart event
  document.addEventListener("productAddedToCart", showToast);
})();